export default __webpack_public_path__ + "static/media/AllProductCalender.bb0ca556.svg";